import script from "./oknonewclient.vue?vue&type=script&setup=true&lang=js"
export * from "./oknonewclient.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__